/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ErrorResponse = {
    properties: {
        message: {
    type: 'string',
    isRequired: true,
},
        code: {
    type: 'string',
},
    },
};